import { render, staticRenderFns } from "./DriverSearchBoxV2.vue?vue&type=template&id=1ba56f11&"
import script from "./DriverSearchBoxV2.vue?vue&type=script&lang=js&"
export * from "./DriverSearchBoxV2.vue?vue&type=script&lang=js&"
import style0 from "./DriverSearchBoxV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports